import styled, { CSSObject } from 'styled-components'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { PriceElementBaseProps } from '../../price-element-interface'

export const PriceElementPeriodUi = styled.div`
  width: 340px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const PriceElementPeriodDescriptionWrapperUi = styled.div`
  width: 270px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-end;
  position: relative;
`

const getPriceElementPeriodSavingUiStylesForLocale = (
  locale: PageLocaleEnum,
): CSSObject => {
  switch (locale) {
    case PageLocaleEnum.DEUTSCH:
      return {
        position: 'absolute',
        bottom: '30px',
        right: '0',
      }
    case PageLocaleEnum.DANISH:
      return {
        position: 'absolute',
        bottom: '35px',
        right: '0',
      }
    default:
      return {}
  }
}

export const PriceElementPeriodSavingUi = styled.div<PriceElementBaseProps>`
  width: 54px;
  position: relative;
  color: #00a0ff;
  font-family: 'Caveat', cursive !important;
  font-weight: 700;
  font-size: 34px;
  line-height: 31px;
  flex-shrink: 0;
  white-space: nowrap;

  ${p => p.locale && getPriceElementPeriodSavingUiStylesForLocale(p.locale)}
`

export const PriceElementPeriodSavingIconUi = styled.div`
  position: absolute;
  right: -37px;
  top: 30px;
`

const getStylesForLocale = (locale: PageLocaleEnum): CSSObject => {
  switch (locale) {
    case PageLocaleEnum.ENGLISH:
      return {
        left: '-30px',
      }
    case PageLocaleEnum.UKRAINIAN:
      return {
        left: '-34px',
      }
    case PageLocaleEnum.GREEK:
      return {
        left: '-63px',
      }
    case PageLocaleEnum.DANISH:
      return {
        left: '-20px',
      }
    default:
      return {}
  }
}

export const PriceElementPeriodSavingTextUi = styled.span<PriceElementBaseProps>`
  position: absolute;
  white-space: nowrap;
  top: -31px;
  left: 0;

  ${p => p.locale && getStylesForLocale(p.locale)}
`

export const PriceElementPeriodDescriptionUi = styled.div`
  width: 100%;
  padding-right: 10px;
  color: #142d63;
  font-weight: 600;
  font-size: 25px;
  line-height: 35px;
`

export const PriceElementPeriodSwitcherUi = styled.div`
  width: 270px;
  display: flex;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  border-radius: 5px;
  overflow: hidden;
`

interface PriceElementPeriodBtnUiStylesInterface {
  isActive: boolean
  isDisabled: boolean
}

export const PriceElementPeriodBtnUi = styled.button<PriceElementPeriodBtnUiStylesInterface>`
  width: 100%;
  line-height: inherit;
  font-weight: inherit;
  font-size: inherit;
  padding: 6px 0;
  background-color: ${p =>
    p.isActive && p.isDisabled ? '#e4e8f0' : p.isActive ? '#00a0ff' : 'white'};
  color: ${p =>
    p.isActive ? 'white' : !p.isActive && p.isDisabled ? '#e4e8f0' : '#00a0ff'};
  cursor: ${p => (p.isActive || p.isDisabled ? 'default' : 'pointer')};
  transition:
    background-color 0.3s ease-in-out,
    border-color 0.3s ease-in-out,
    color 0.3s ease-in-out;
  border: ${p =>
    p.isActive && !p.isDisabled
      ? '0.5px solid #00a0ff'
      : '0.5px solid #e4e8f0'};
  &:first-child {
    border-radius: 5px 0 0 5px;
    border-right: none;
  }
  &:last-child {
    border-radius: 0 5px 5px 0;
    border-left: none;
  }
`
